export default __webpack_public_path__ + "static/media/Icon=Doctors.2c26a961.svg";